import {Component, Vue} from 'vue-property-decorator';
import {VFormData} from '@/utils/VFormData';
import {AxiosResponse} from 'axios';

@Component
export default class ChunForm extends Vue {
  public formData: VFormData<any>;

  public $refs: { form: any };

  public extractError(response: AxiosResponse) {
    this.formData.extractErrorsFromResponse(response);

  }

  public created() {
    Object.keys(this.formData.data).forEach((key) => {
      this.$watch(`formData.data.${key}`, function() {
        if (this.formData.errors[key].length > 0) {
          this.formData.resetErrors(key);
        }
      });
    });

  }
}
